import { Deferred } from '@trello/deferred';

// eslint-disable-next-line @trello/no-module-logic
export const channelDeferred = new Deferred<'stable' | 'alpha'>({
  msUntilFallback: 5000,
  value: 'stable',
});
